<template>
<CImg v-if="src" :src="src" :style="{maxWidth: maxWidth}" :class="{'circle': circle}" class="avatar w-auto img-thumbnail" :alt="alt" />
<FaIcon v-else icon="user" :style="{width: maxWidth, height: maxWidth}" :class="{'circle': circle}" class="font-sm avatar border-affili-eggplant img-thumbnail text-affili-eggplant" :alt="alt" />
</template>

<script>
export default {
    name: 'Avatar',

    props: {
        src: {
            default: null,
            type: [String, null]
        },
        alt: {
            default: ''
        },
        maxWidth: {
            default: '50px'
        },
        circle: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
.avatar {
    height: auto;
    max-height: 100px;
    background-color: transparent!important;
}
.circle {
    border-radius: 100% !important;
    padding: 20px;
}
</style>